import { api } from 'utility';

import {
  getCaptchaServiceUrl
} from 'URLs';


export async function getCaptcha() {
  return api.get(getCaptchaServiceUrl(), {  }).then((res) => res.data);
}

export default {
  getCaptcha,

};
